import React from 'react';
import * as _ from 'lodash';
import types from 'utils/prop-types';
import { ToAcronym } from 'utils/strings';
import loadImage from 'utils/load-image';
import { Tooltip } from 'react-tooltip';
import './display-picture.scss';

class DisplayPicture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
        };
    }

    componentDidMount() {
        this.setState({ id: _.uniqueId('tooltip-display-picture-') });
    }

    render() {
        const { user } = this.props;
        const classNames = _.get(this, 'props.classNames', ``);
        return (
            <div className={`bk-display-picture ${classNames}`} data-tooltip-id={this.state.id}>
                {user.display_picture ? (
                    <img src={user.display_picture} alt="User avatar" />
                ) : user.name ? (
                    <div className="acronym">
                        <span>{ToAcronym(user.name)[0]}</span>
                    </div>
                ) : (
                    <img src={loadImage('default-display-picture.png')} alt="User avatar" />
                )}
                {user.name && (
                    <Tooltip className="tooltip" id={this.state.id}>
                        {user.name}
                    </Tooltip>
                )}
            </div>
        );
    }
}

DisplayPicture.propTypes = {
    user: types.user,
};

export default DisplayPicture;
